export default __webpack_public_path__ + "static/media/Android Webview.e1c23116.svg";